import debounce from 'lodash.debounce';
import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';

import {
  AUTOCOMPLETION_DEFAULT_DEBOUNCE_TIME_MS,
  AUTOCOMPLETION_ITEMS_DEFAULT_LIMIT,
  AUTOCOMPLETION_CONSUMER,
} from '../constants';

import JOB_ROLE_SUGGESTIONS_QUERY from './jobRoleSuggestionQuery.graphql';

export const useJobRoleAutocompletion = (
  limit = AUTOCOMPLETION_ITEMS_DEFAULT_LIMIT,
  debounceTime = AUTOCOMPLETION_DEFAULT_DEBOUNCE_TIME_MS
) => {
  const [jobRoleSuggestions, setJobRoleSuggestions] = useState([]);
  const [getSuggestions, { data, loading, called }] = useLazyQuery(
    JOB_ROLE_SUGGESTIONS_QUERY
  );

  const fetchJobRoleSuggestions = useMemo(
    () =>
      debounce(query => {
        getSuggestions({
          variables: {
            consumer: AUTOCOMPLETION_CONSUMER,
            text: query,
          },
        });
      }, debounceTime),
    [debounceTime, getSuggestions]
  );

  useEffect(() => {
    if (!loading && called) {
      const collection =
        data && data.autocompletionProfileJobRole
          ? data.autocompletionProfileJobRole.collection
          : [];
      const suggestions =
        collection && collection.length > 0
          ? collection
              .slice(0, limit)
              .reduce(
                (acc, { suggestion }) =>
                  suggestion ? [...acc, suggestion] : acc,
                []
              )
          : [];

      setJobRoleSuggestions(suggestions);
    }
  }, [loading, data, limit]);

  return { jobRoleSuggestions, fetchJobRoleSuggestions };
};
